import { Tab as HeadlessUITab } from "@headlessui/react";
import clsx from "clsx";
import React from "react";
import { AlertIcon } from "../icons";
import type { ChildrenProps } from "../types";
import { TabFloater } from "./tab-floater";

/** Props Interface */
interface TabProps extends ChildrenProps {
	isDisabled?: boolean;
	count?: number | string;
	errors: string[] | null;
	rightIcon?: React.ReactNode;
	cyId: string;
}

export function Tab({ children, isDisabled, count, errors, rightIcon, cyId }: TabProps) {
	/** Render */
	return (
		<HeadlessUITab
			as={React.Fragment}
			disabled={isDisabled}
		>
			{({ selected }) => (
				<div
					className={clsx(
						"tab-item",
						"inline-flex px-4 flex-row gap-2 items-center",
						"shrink-0",
						"relative",
						"data-disabled:opacity-50! data-disabled:cursor-not-allowed!",
						"active:opacity-50",
						"px-3 h-7.5",
						"text-xs",
					)}
					data-cy={cyId}
				>
					<React.Fragment>
						{children}
						{errors?.length ? <AlertIcon variant="warning" /> : null}
						{/* `!= null`, not truthiness: a count of 0 must render as the styled, muted
						    zero — the bare `0` a falsy check leaks glues itself to the label. */}
						{count != null && <span className="opacity-50">{count}</span>}
						{selected && <TabFloater hasError={!!errors?.length} />}
						{rightIcon && <span className="ml-auto">{rightIcon}</span>}
					</React.Fragment>
				</div>
			)}
		</HeadlessUITab>
	);
}
